import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";

export const Navbar = ({ onBookClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();

  const navLinks = [
    { name: t.nav.services, href: "#tjanster" },
    { name: t.nav.fleet, href: "#bilar" },
    { name: t.nav.about, href: "#om-oss" },
    { name: t.nav.contact, href: "#kontakt" },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-neutral-950/80 backdrop-blur-xl border-b border-white/5">
      <div className="section-container">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3" data-testid="navbar-logo">
            <span className="text-white font-bold text-lg">Taxi Kalmar</span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="nav-link text-sm"
                data-testid={`nav-link-${link.name.toLowerCase().replace(/\s/g, '-')}`}
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center gap-4">
            {/* Language Switcher */}
            <div className="lang-switch" data-testid="language-switcher">
              <button
                onClick={() => setLanguage('sv')}
                className={`lang-btn ${language === 'sv' ? 'active' : ''}`}
                data-testid="lang-sv-btn"
              >
                SV
              </button>
              <button
                onClick={() => setLanguage('en')}
                className={`lang-btn ${language === 'en' ? 'active' : ''}`}
                data-testid="lang-en-btn"
              >
                EN
              </button>
            </div>

            <a
              href="tel:0480474717"
              className="flex items-center gap-2 text-white hover:text-yellow-500 transition-colors"
              data-testid="navbar-phone"
            >
              <Phone className="w-4 h-4" />
              <span className="font-medium">0480 47 47 17</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="flex lg:hidden items-center gap-3">
            {/* Mobile Language Switcher */}
            <div className="lang-switch" data-testid="mobile-language-switcher">
              <button
                onClick={() => setLanguage('sv')}
                className={`lang-btn ${language === 'sv' ? 'active' : ''}`}
              >
                SV
              </button>
              <button
                onClick={() => setLanguage('en')}
                className={`lang-btn ${language === 'en' ? 'active' : ''}`}
              >
                EN
              </button>
            </div>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white p-2"
              data-testid="mobile-menu-btn"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-6 border-t border-white/5">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="nav-link text-base py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <a
                href="tel:0480474717"
                className="flex items-center gap-2 text-white py-2"
              >
                <Phone className="w-4 h-4" />
                <span>0480 47 47 17</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
